import { render, staticRenderFns } from "./payment-page.vue?vue&type=template&id=22874454&scoped=true"
import script from "./payment-page.vue?vue&type=script&lang=js"
export * from "./payment-page.vue?vue&type=script&lang=js"
import style0 from "./payment-page.vue?vue&type=style&index=0&id=22874454&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22874454",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22874454')) {
      api.createRecord('22874454', component.options)
    } else {
      api.reload('22874454', component.options)
    }
    module.hot.accept("./payment-page.vue?vue&type=template&id=22874454&scoped=true", function () {
      api.rerender('22874454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/list/payment-page.vue"
export default component.exports